import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Resource, Identifiable } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  unAssignCalendarHolidaysFromResource(
    request: Boundaries["unAssignCalendarHolidaysFromResource"]["request"],
  ): void;
}

function useUnAssignCalendarHolidaysFromResource(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isUnAssignCalendarHolidaysFromResourcePending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isUnAssignManagerFromResourceRequestFailure(resource),
    ),
    unAssignCalendarHolidaysFromResource:
      core.unAssignCalendarHolidaysFromResource,
  };
}

export { useUnAssignCalendarHolidaysFromResource };
